import { CognitoEnvironmentValues } from 'utils/environment';

export const USER_POOL_ID = CognitoEnvironmentValues.userPoolId();
export const USER_POOL_CLIENT_ID = CognitoEnvironmentValues.userPoolClientId();
export const USER_POOL_ENDPOINT = `https://cognito-idp.${CognitoEnvironmentValues.awsRegion()}.amazonaws.com/`;
